export default function transformPipelineTagsToOptions(pipelineTags) {
  if (!pipelineTags) {
    return [];
  }
  return pipelineTags.map(({ tag }) => ({
    id: tag.id,
    label: tag.label,
  }));
}
